/*
These are the site settings that will be used by the local dev server
*/
define(function (require, exports, module) {
    const appInfoSource = document.getElementById('appInfo');
    const appInfo = (appInfoSource && JSON.parse(appInfoSource.innerText)) || {};
    const reportingSuiteId = appInfo.tracking_suite;

    const language = appInfo.language;
    const locale = appInfo.locale;
    const safeLang = language ?? locale; // Allow for section partials compat.
    const basename = `${safeLang === 'es' ? '/es' : safeLang === 'ja' ? '/ja' : ''}/gameday`;
    let deviceType = 'desktop';
    let platform = '';
    if (window.deviceBootstrap) {
        deviceType = window.deviceBootstrap().formFactor;
        platform = window.deviceBootstrap().platform;
    }
    let device = '';
    if (platform === 'ios') {
        device = deviceType === 'phone' ? 'iphone' : 'ipad';
    } else if (platform === 'android') {
        device = 'android';
    }

    // For FV launch, disable FV by default on mobile devices.
    const adDevice = `${deviceType}${device ? '/' : ''}${device}`;
    const adUnit = 'gameday-live';
    const adLocaleStr = `${safeLang === 'es' ? 'es.' : safeLang === 'ja' ? 'ja.' : ''}`;

    const properties = {
        mount: '#gameday-index-component__root',
        game: {
            locale,
            language,
            game: appInfo.game_pk,
            game_state: appInfo.state,
            game_tab: appInfo.tab,
            dataMode: 'gumbo',
            game_pk: appInfo.game_pk,
            logging: appInfo.logging,
            bullpen_friendly: appInfo.bullpen_friendly,
            debug: true,
            scoreboard: {
                preferMLB: true
            },
            basename,
            detail: appInfo.detail
        },
        config: {
            env: appInfo.env || 'prod',
            logging: 'log',
            adRefreshRate: 60,
            appView: 'web',
            locale: appInfo.locale,
            language: appInfo.language,
            season: appInfo.season,
            siteProperty: 'mlb',
            dictionary: appInfo.dictionary || null,
            siteLabel: appInfo.siteLabel || '',
            seoSitePrefix: appInfo.seoSitePrefix || '',
            enableFieldVision: true,
            enableFieldVisionOD: true,
            forceFieldVisionOn: false,
            deviceType,
            videoAdsVolume: '10',
            videoAdsMute: true,
            showVideoAds: true,
            disableWebSockets: false,
            webSocketWindow: 18,
            batEnabled: true,
            forceDFV: false,
            enablePOTG: false,
            teamInfo: window?.team_info,
            useFallbackTeamUrl: true
        },
        ads: {
            adRefreshRate: 30,
            env: appInfo.env,
            adUnitHierarchy1: `${adLocaleStr}mlb.mlb`,
            adUnitHierarchy2: '/xgameday',
            inventoryHierarchy: '/xgameday',
            thresholds: [0, 670, 768, 980, 1024],
            thresholdsMap: ['xs', 's', 'm', 'l', 'xl'],
            thresholdsMediaQueries: [
                window.matchMedia('(max-width: 669px)'),
                window.matchMedia('(min-width: 670px) and (max-width: 767px)'),
                window.matchMedia('(min-width: 768px) and (max-width: 979px)'),
                window.matchMedia('(min-width: 980px) and (max-width: 1023px)'),
                window.matchMedia('(min-width: 1024px)')
            ],
            units: {
                presby: {
                    refresh: false,
                    init: true,
                    container: 'ad-114x48-presby',
                    sizes: [
                        [114, 48]
                    ],
                    thresholds: [0, 1, 2, 3, 4, 5],
                    inventoryHierarchy: '/xgameday',
                    targeting: {
                        pos: '1'
                    }
                },
                parallax: {
                    refresh: true,
                    init: true,
                    container: 'ad-300x250-parallax',
                    sizes: [[300, 250]],
                    thresholds: [0, 1, 2, 3, 4, 5],
                    targeting: {
                        pos: '2'
                    }
                },
                topBanner: [{
                    refresh: true,
                    container: 'ad_top_728',
                    thresholds: '[3,4,5,6]',
                    sizes: '[[728,90]]',
                    targeting: {
                        pos: '3'
                    }
                }],
                midInning: [{
                    refresh: false,
                    init: true,
                    container: 'ad-300x250-midinning',
                    sizes: [[300, 250]],
                    inventoryHierarchy: '/xgameday-live',
                    thresholds: [0, 1, 2, 3, 4, 5],
                    targeting: {
                        pos: '1'
                    }
                }]
            },
            responsive: true,
            iu: `/2605/${adLocaleStr}xgameday/${adDevice}`,
            pp: deviceType === 'desktop' ? 'mlb_csai_vod_desktop' : 'mlb_csai_vod_mobile',
            prerollIu: {
                highlight: `/2605/${adLocaleStr}mlb.video/xgameday/${adDevice}`,
                midinning: `/2605/${adLocaleStr}xgameday.video/mlb/${adUnit}`
            },
            video: {
                adSources: [
                    'publica',
                    'aps'
                ],
                publica: {
                    siteIds: {
                        midinning: 29387,
                        highlight: 57815
                    },
                    site_name: 'mlb',
                    site_page: 'https://www.mlb.com/',
                    custom_6: 'major'
                }
            }
        },
        sponsor: '',
        tracking: {
            suite: {
                desktop: reportingSuiteId,
                mobile: 'mlbglobal08,mlbwapdev'
            },
            props: {
                pageName: 'Major League Baseball: Gameday',
                channel: 'Gameday',
                prop1: 'Gameday Initial Load',
                currencyCode: 'USD',
                omnitureSetting: {
                    eVar73: reportingSuiteId
                }
            }
        },
        skin: {},
        rules: {}
    };

    // For now, lets make sure tfs works for dev
    // We can probably handle this as part of the standard url parsing
    // maybe move it to the hash
    const params = new URLSearchParams(location.search);
    const timecode = params.get('tfs');
    const appOverride = params.get('appOverride');
    const enableFieldVisionOverride = params.get('enableFieldVision');
    const enableFieldVisionODOverride = params.get('enableFieldVisionOD');
    const forceFieldVisionOn = params.get('forceFV') === 'true';
    const enableDarkMode = params.get('enableDarkMode');
    const forceWebSockets = params.get('forceWS');
    const noDelayWS = params.get('noDelayWS');
    const forceDFV = params.get('forceDFV') === 'true';
    const stitchEnv = params.get('stitch_env');
    const enablePOTG = params.get('enablePOTG');

    if (timecode) {
        properties.game.timecode = timecode;
    }

    if (appOverride !== null) {
        properties.config.appOverride = appOverride;
    }

    if (enableFieldVisionOverride !== null) {
        properties.config.enableFieldVision = enableFieldVisionOverride === 'true';
    }

    if (enableFieldVisionODOverride !== null) {
        properties.config.enableFieldVisionOD = enableFieldVisionODOverride === 'true';
    }

    if (enableDarkMode !== null) {
        properties.config.enableDarkMode = enableDarkMode === 'true';
    }

    if (noDelayWS !== null) {
        properties.config.noDelayWebSockets = noDelayWS === 'true';
    }

    if (stitchEnv !== null) {
        properties.config.stitchEnv = stitchEnv;
    }

    if (enablePOTG !== null) {
        properties.config.enablePOTG = true;
    }

    properties.config.forceFieldVisionOn = forceFieldVisionOn;
    properties.config.forceWebSockets = forceWebSockets === 'true' ? true : forceWebSockets === 'false' ? false : null;
    properties.config.forceDFV = forceDFV;

    return properties;
});
